import { useCallback } from 'react';
import { phoneText } from '../../src/index';
import { useAdmin } from '../session';

/**
 * D580: the one way a console screen writes a phone. The operator's scope country makes a phone of that country read in
 * its national pattern; any other reads internationally; a masked phone stays masked (`phoneText`, `@vello/format`).
 * Never format a phone inline — call this.
 */
export function usePhoneText(): (raw: string | undefined) => string {
  const { scope } = useAdmin();
  const home = scope.current.country;
  return useCallback((raw) => phoneText(raw, home), [home]);
}
